const analyticsGA4 = {
  globalFunctions: {
    login(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'login'
        rest.language_code = data.ctx.i18n.locale ? data.ctx.i18n.locale.toUpperCase() : ''
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_business_type = data.payload.businessType ? data.payload.businessType : 'B2C'
        rest.page_lang = data.payload.mainConfig.analyticLang
        rest.page_section = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_web_type = data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'
        rest.user_agent = navigator.userAgent
        rest.validation = data.payload.validation
        if (data.payload.user) {
          rest.gender = data.payload.user.gender ? data.payload.user.gender : ''
          rest.nationality = data.payload.user.country ? data.payload.user.country : ''
          rest.user_id = data.payload.user.partyId
          rest.points = data.payload.user.total
          rest.tier_loyalty = data.payload.user.category ? data.payload.user.category.toLowerCase() : ''
          rest.profile = data.payload.user.programs
            ? data.payload.user.programs[0] === 'NH_DISCOVERY'
              ? 'MINOR_DISCOVERY'
              : data.payload.user.programs[0]
            : '';
        }
        return rest
      })[0]
    },
    select_experience(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'select experience'
        rest.city = data.payload.offer.hotelList.hotel ? data.payload.offer.hotelList.hotel.metadata.location.key : 'Multiple'
        rest.experience_category = data.payload.offer.category.key ? data.payload.offer.category.key : ''
        rest.experience_date = data.payload.offer.fIni ? data.ctx.$moment(data.payload.offer.fIni).format('DD-MM-YYYY') : '' + '-' + data.payload.offer.fFin ? data.ctx.$moment(data.payload.offer.fFin).format('DD-MM-YYYY') : ''
        rest.experience_id = data.payload.offer.id ? data.payload.offer.id : ''
        rest.experience_price = data.payload.offer.content.price
        rest.hotel_brand = data.payload.offer.hotelList.hotel ? data.payload.offer.hotelList.hotel.metadata.brand : 'Multiple'
        rest.hotel_name = data.payload.offer.hotelList.hotel ? data.payload.offer.hotelList.hotel.content.text.content.titleSection : 'Multiple'
        rest.language_code = data.ctx.i18n.locale ? data.ctx.i18n.locale.toUpperCase() : ''
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_business_type = data.payload.businessType ? data.payload.businessType : 'B2C'
        rest.page_lang = data.payload.mainConfig.analyticLang
        rest.page_section = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_web_type = data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'
        return rest
      })[0]
    },
    submit_form(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'submit_form'
        rest.form_id = data.payload.form.id
        rest.form_name = data.payload.form.name
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.hotel_id = data.payload.hotel_id
        rest.validation = data.payload.validation
        rest.transaction_id = data.payload.transaction_id
        rest.page_lang = data.payload.page_lang
        return rest
      })[0]
    },
    logout(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'logout'
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.page_lang
        return rest;
      })[0];
    },
    pop_up_login_gha(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'pop_up_login_gha'
        rest.language_code = data.ctx.i18n.locale ? data.ctx.i18n.locale.toUpperCase() : ''
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_business_type = data.payload.businessType ? data.payload.businessType : 'B2C'
        rest.page_lang = data.payload.mainConfig.analyticLang
        rest.page_section = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_web_type = data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'
        return rest;
      })[0];
    },
    call_us_to_book(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'call_us_to_book'
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.mainConfig? data.payload.mainConfig.analyticLang : ''
        return rest
      })[0]
    },
    sign_up_button(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'sign_up_button'
        rest.language_code = data.ctx.i18n.locale ? data.ctx.i18n.locale.toUpperCase() : ''
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_business_type = data.payload.businessType ? data.payload.businessType : 'B2C'
        rest.page_lang = data.payload.mainConfig.analyticLang
        rest.page_section = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_web_type = data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'
        return rest
      })[0]
    },
    start_form(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'start_form'
        rest.form_id = data.payload.form.id
        rest.form_name = data.payload.form.name
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.page_lang
        return rest
      })[0]
    },
    error_field(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'error_field'
        rest.field_id = data.payload.fieldID
        rest.form_id = data.payload.form.id
        rest.form_name = data.payload.form.name
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.page_lang
        return rest
      })[0]
    },
    stop_form(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'stop_form'
        rest.form_id = data.payload.form.id
        rest.form_name = data.payload.form.name
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.page_lang
        return rest
      })[0]
    },    
    forgot_password(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'forgot_password'
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.mainConfig ? data.payload.mainConfig.analyticLang : ''
        return rest
      })[0]
    },
    change_language(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'change_language'
        rest.nhScreen = data.payload.content.meta.websection
        rest.selected_language = data.payload.language
        rest.page_lang = data.payload.mainConfig ? data.payload.mainConfig.analyticLang : ''
        return rest
      })[0]
    },
    detect_adblock(data) {
      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'detect_adblock'
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_lang = data.payload.page_lang
        return rest
      })[0]
    },
    search_product(data) {
      var formatDateGA4 = (date) => {
        var day = date.split('/')[0]
        var month = date.split('/')[1]
        var year = date.split('/')[2]
        return year + "/" + month + "/" + day;
      }
      const oneDay = 24 * 60 * 60 * 1000
      const firstDate = new Date(formatDateGA4(data.payload.search.date.fini))
      const secondDate = new Date(formatDateGA4(data.payload.search.date.fout))
      const currentDay = new Date()
      const daysInAdvance = Math.round(Math.abs((currentDay - firstDate) / oneDay))
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay))

      var adults = 0
      var babies = 0
      var children = 0
      const occupancy = data.payload.search.occupancy
      occupancy.forEach(element => {
        adults += element.nadults
        babies += element.nbabies
        children += element.nchilds
      })
      const typeSearch = data.payload.search.destination.typeSearch
      const dataB2B = data.payload.dataB2B
      const contract = dataB2B && dataB2B.contract ? dataB2B.contract : ''
      const b2bCompanyContract = contract.includes("MASTER") ? "MASTER" : contract.includes("ELITE") ? "ELITE" : contract.includes("ADVANCE") ? "ADVANCE" : contract.includes("SMART") ? "SMART" : contract
      const eventIdCGW = data.payload.eventIdCGW
      if (data.payload.searchbar && data.payload.searchbar.fini) {
        var [day, month, year] = data.payload.searchbar.fini.split('/');
        var date = new Date(`${year}-${month}-${day}`);
        var dayOfWeek = date.getDay();
        var adjustedDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
      }

      return data.objSchema.map(({ event, ...rest }) => {
        rest.event = 'search_product'
        rest.cro_proposal = data.payload.searchbar && data.payload.searchbar.queryString && data.payload.searchbar.queryString.croproposal ? parseInt(data.payload.searchbar.queryString.croproposal) : null
        rest.day_of_week = data.payload.searchbar && data.payload.searchbar.queryString && data.payload.searchbar.queryString.croproposal ? adjustedDayOfWeek : null
        rest.adults = adults
        rest.babies = isNaN(babies) ? 0 : babies
        rest.b2b_program = b2bCompanyContract
        rest.children = children
        rest.city = data.payload.search.destination.city
        rest.contract = dataB2B && dataB2B.company ? dataB2B.company : ''
        rest.country = data.payload.search.destination.countryName
        rest.coupon = data.payload.search.voucherCode
        rest.days_in_advance = daysInAdvance
        rest.dsclid = data.payload.dsclidParam || null
        rest.end_date = formatDateGA4(data.payload.search.date.fout)
        rest.group_id = eventIdCGW && eventIdCGW.group_id ? eventIdCGW.group_id : ''
        rest.hotel_id = typeSearch === 'poi' ? '' : data.payload.search.destination.code
        rest.item_brand = data.payload.search.destination.brand
        rest.language_code = data.ctx.i18n.locale ? data.ctx.i18n.locale.toUpperCase() : ''
        rest.lead_id = eventIdCGW && (!eventIdCGW.group_id && eventIdCGW.lead_id) ? eventIdCGW.lead_id : ''
        rest.nhScreen = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.number_of_nights = diffDays
        rest.number_of_rooms = occupancy.length
        rest.occupation = diffDays + '|' + adults + '|' + children + '|' + (isNaN(babies) ? 0 : babies)
        rest.page_business_type = data.payload.businessType ? data.payload.businessType : data.payload.pageBusinessType != '' ? data.payload.pageBusinessType : 'B2C'
        rest.page_lang = data.ctx.i18n.locale ? data.payload.mainConfig[data.ctx.i18n.locale + '-MainConfig'].analyticLang : ''
        rest.page_product = typeSearch === 'poi' ? '' : data.payload.pageProduct
        rest.page_section = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        rest.page_web_type = data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'
        rest.quantity = diffDays * occupancy.length
        rest.search_term = (typeSearch === 'poi' ? '' : data.payload.search.destination.code) + '|' + data.payload.search.date.fini + '-' + data.payload.search.date.fout + '|' + diffDays + '|' + adults + '|' + children + '|' + (isNaN(babies) ? 0 : babies)
        rest.search_type = typeSearch
        rest.start_date = formatDateGA4(data.payload.search.date.fini)
        return rest
      })[0]
    }
  }
}
export default analyticsGA4
